import React, { useEffect, useMemo, useState } from "react";
import api_requests from "../../resources/api_requests";
import utils, { detectPaytmMiniApp } from "../../resources/utils";
import { useNavigate } from "react-router-dom";
import constant from "../../resources/constant";
import { useDispatch } from "react-redux";
import { hide_loader, show_loader } from "../../actions/app";
import Link from "../../modules/Link";
import { useLoginSuccess } from "../../hooks/auth";
import PaytmLogin from "./components/PaytmLogin";
import { useTranslation } from "react-i18next";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginSuccess } = useLoginSuccess();
  const selectedCountry = utils._retrieveData(constant.SELECTED_COUNTRY);
  const { t } = useTranslation();

  const [mobile, set_mobile] = useState("");
  const [email, set_email] = useState("");
  const [password, set_password] = useState("");

  useEffect(() => {
    const auth_token = utils._retrieveData(constant.AUTH_TOKEN);
    if (auth_token) {
      navigate("/");
      return;
    }
  }, [navigate]);

  const handle_mobile = (e) => {
    if (e.target.value === "" || e.target.value.length <= 10)
      set_mobile(e.target.value);
  };

  const handle_email = (e) => {
    set_email(e.target.value);
  };

  const on_login = async () => {
    try {
      dispatch(show_loader());
      let res;
      if (selectedCountry === "india") {
        res = await api_requests.login({
          mobile,
          password,
        });
      } else if (selectedCountry === "indonesia") {
        res = await api_requests.login({
          email: email.toLowerCase().trim(),
          password,
        });
      }

      if (res?.success) {
        loginSuccess(res);
        console.log("HERE!!!");
        navigate("/business-select", { replace: true });
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const btn_disable = useMemo(() => {
    let val = true;
    if (selectedCountry === "india") {
      if (mobile !== "" && password !== "" && mobile.length === 10) {
        val = false;
      }
    } else if (selectedCountry === "indonesia") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email !== "" && password !== "" && emailRegex.test(email)) {
        val = false;
      }
    }
    return val;
  }, [mobile, email, password, selectedCountry]);

  if (detectPaytmMiniApp()) return <PaytmLogin />;

  return (
    <div className="px-6 pt-10 font-custom">
      <div className="flex flex-col items-center gap-0.5 justify-center">
        <p className="font-custom  text-2xl font-semibold text-[#7953D2] ">
          {t("welcome_abord")}!
        </p>
        <p className="font-custom text-sm text-xs font-medium text-dark_gray ">
          {t("login_to_start")}
        </p>
      </div>

      <div className="relative rounded-[20px] bg-white shadow-[0px_0px_8px_rgba(166,166,166,0.25)] p-8 mt-20 ">
        <div className="form-control pt-2">
          <label
            htmlFor="saveAddress"
            className="font-custom block mb-2 text-sm font-semibold text-[#492897]"
          >
            {selectedCountry === "india" ? t("mobile_number") : t("email_label")}
          </label>
          {selectedCountry === "india" ? (
            <input
              type="number"
              value={mobile}
              onChange={handle_mobile}
              className="font-custom  font-semibold  border border-[#7953D233] text-dark_black text-xs rounded-lg  p-2 px-5 py-[12px] pl-3 focus:outline-none "
              placeholder={t("enter_mobile_number")}
            />
          ) : (
            <input
              type="email"
              value={email}
              onChange={handle_email}
              className="font-custom  font-semibold  border border-[#7953D233] text-dark_black text-xs rounded-lg  p-2 px-5 py-[12px] pl-3 focus:outline-none "
              placeholder={t("email_placeholder")}
            />
          )}
        </div>
        <div className="form-control mt-10">
          <label
            htmlFor="saveAddress"
            className="font-custom block mb-2 text-sm font-semibold text-[#492897]"
          >
            {t("password")}
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => set_password(e.target.value)}
            className="font-custom  font-semibold  border border-[#7953D233] text-dark_black text-xs rounded-lg  p-2 px-5 py-[12px] pl-3 focus:outline-none "
            placeholder={t("enter_password")}
          />
        </div>
        <div className="flex justify-between mt-2">
          {/* Login via otp */}
          <div></div>
          <a
            className="text-stone-900 text-xs font-medium font-custom"
            href="/forgot-password"
          >
            {t("forgot_password")}?
          </a>
        </div>
        <div className="mt-8">
          <button
            disabled={btn_disable}
            onClick={on_login}
            className={`font-custom w-full py-3 rounded-[30px] text-base font-semibold
            ${btn_disable
              ? "bg-gray text-gray-200 cursor-not-allowed"
              : "bg-[#492897] text-white"}
            `}
          >
            {t("login")}
          </button>
        </div>
      </div>

      <div className="flex items-center mt-5 justify-center font-custom text-stone-900 text-xs font-semibold font-custom">
        <div className="mr-1">{t("dont_have_account")}?</div>
        <Link to="/sign-up">{t("sign_up")}</Link>
      </div>
    </div>
  );
};

export default Login;